// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'mail-solid';

export const Component = () => (
  <g fill='currentColor' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M16.438 14.49H1.563V5.33l5.399 4.153a3.344 3.344 0 0 0 4.076 0l5.4-4.153z' />
    <path d='M9.82 7.898a1.345 1.345 0 0 1-1.64 0L2.938 3.864h12.127z' />
  </g>
);

export const viewBox = '0 0 18 18';
